import {FrmShape} from "./FrmShape";
import {FrmShapeLine} from "./FrmShapeLine";

export type ConstraintType = "equal-length";

export class FrmShapeConstraint {
    shape: FrmShape;
    lines: FrmShapeLine[];
    type: "equal-length";

    constructor(shape: FrmShape, type: ConstraintType, lines: FrmShapeLine[]) {
        this.shape = shape;
        this.type = type;
        this.lines = lines;
    }
}
